import { Progress } from "@/components/ui/progress";

interface ProgressSectionProps {
  averageScore: number;
}

export const ProgressSection = ({ averageScore }: ProgressSectionProps) => {
  return (
    <div className="space-y-2">
      <h4 className="text-sm font-medium text-gray-700">Overall Progress</h4>
      <div className="space-y-2">
        <div className="flex justify-between text-sm">
          <span>Average Score</span>
          <span className="font-medium">{averageScore}%</span>
        </div>
        <Progress value={averageScore} className="h-2" />
      </div>
    </div>
  );
};